import React from 'react';
import * as productAction from './../../actions/product';
import callApi from './../../utils/apicaler';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import {
  Link
} from "react-router-dom"; 

class Products extends React.Component{
    constructor(props){
            super(props);
            this.state = {
                status:0
            }
    }
    componentDidMount(){
        const { productActionCreator } = this.props;
        const { fetchListProduct } = productActionCreator;
        fetchListProduct()
        

    }


      showTable = (datas, status) =>{
        var result = null;
            result = datas.map((product, index)=>{
                return ( 
                    <div className="col-xs-6 col-sm-4 col-md-4 col-lg-3" style={{paddingRight:"6px", paddingLeft: "6px"}} id={ product.price ? "" : "display_not"} key={index}>
                        <Link to={`product/${product._id}`}>
                            <div className="colection1" >
                            {product.sale === "HET HANG" ? <p style={{background:"red"}}>Hết hàng</p> : product.sale === "SALE" ? <p style={{background:"red"}}>{`Sale ${product.salePrice}`}</p> : <p>New</p>}
                            
                            <img src={product.imgeFile} />

                            </div>
                            <div className="title_product">
                                <b>{product.products.slice(0,28)}...</b>
                                <hr/>
                                {product.sale === "SALE" ? 
                                <span>
                                <span style={{textDecoration: product.sale === "SALE" ? "line-through" : ""}}>{product.price}.000 Vnd</span>
                                <br/>
                                <b style={{fontSize:"17px", color:"red"}}>{((parseInt(product.price)*(1 - parseInt(product.salePrice)/100.0)))}.000VND</b>
                                </span>
                                :
                                <span>{product.price}.000VND</span>
                                }
                            </div>
                        </Link>
                    </div> 
                )
            })
        return result
    }
    render(){
        const {listProducts} = this.props;
        const {status} = this.state;
        return(
            <div className="row custom_row">
                <div className="out_soure">
                    <div className="img_out" style={{background:"none",height:"229px"}}>
                        <div className="deb">
                            <span className="t1"> <b>●</b> &nbsp;TAKE A LOOK</span>
                        </div>
                        <h3>Sản phẩm mới</h3>
                        <p>Những sản phẩm thời trang mới nhất/hot nhất</p>
                    </div>
                </div>
                <div className="box_main">
                    {
                        listProducts ? 
                        this.showTable(listProducts, status) : 
                        <div className="loading" style={{marginTop:"0", padding:"40px"}}>Loading&#8230;</div>
                    }
                </div>
                <div className="row custom_row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
                        <div className="send_mail">
                            <Link to="/xemthem">
                                <button type="button"> Xem thêm </button>
                            </Link>
                        </div>
                    </div>
                </div>
                
            </div>
            
        )
    }
}

Products.propTypes = {
    productActionCreator: PropTypes.shape({
        fetchListProduct: PropTypes.func,
    }),
    listProducts: PropTypes.array,
}

const mapStateToProps = state =>{
    return{
        listProducts : state.products.listProduct,
    };
}
const mapDispatchToProps = dispatch => {
    return {
        productActionCreator: bindActionCreators(productAction, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Products);